import React from 'react';
import { useState } from 'react';
import { Checkbox } from 'antd';
import './EduGuidePopup.scss';
import store from '@store/index';
import intl from 'react-intl-universal';
import { CONFIRM, GO_NOW, NO_REMIND, SHOWN } from '@/components/viewer/ui/constants/edu_guide.constants';
import closeIcon from './assets/close.svg';

const EVENT_LABEL = 'edu_guide_popup';

const storageKey = 'DISMISS_EDU_GUIDE_POPUP';
export function isDismissEduGuidePopup() {
    return localStorage.getItem(storageKey);
}

export function EduGuidePopup() {
    const title = intl.get('EduGuidePopup.title');
    const content = intl.get('EduGuidePopup.content');
    const dismissLabel = intl.get('EduGuidePopup.dismissLabel');
    const confirm = intl.get('EduGuidePopup.confirm');
    const goNow = intl.get('EduGuidePopup.goNow');
    const [checked, setChecked] = useState(false);
    const [visible, setVisible] = useState(true);
    const [isSend, setIsSend] = useState(false);

    function onChange() {
        if (!checked) {
            localStorage.setItem(storageKey, 1);
        } else {
            localStorage.removeItem(storageKey);
        }
        if (!checked) {
            store.userStore.doSendGAEvent({ eventKey: NO_REMIND, label: EVENT_LABEL });
        }
        setChecked(v => !v);
    }
    function onConfirm() {
        setVisible(v => !v);
        store.userStore.doSendGAEvent({ eventKey: CONFIRM, label: EVENT_LABEL });
    }
    function onGoNow() {
        store.userStore.doSendGAEvent({ eventKey: GO_NOW, label: EVENT_LABEL });
        setVisible(() => false);
        window.open('https://www.foxitsoftware.cn/solutions/edu/?from=onlinecarsi');
    }
    function onClose() {
        setVisible(() => false);
    }
    if (visible && !isSend) {
        setIsSend(() => true);
        store.userStore.doSendGAEvent({ eventKey: SHOWN, label: EVENT_LABEL });
    }
    return (
        <div className={`popup-wrapper${visible ? '' : ' hide'}`}>
            <header className="popup-header">
                <div className="popup-title">{title}</div>
                <div className="popup-close" onClick={onClose}>
                    <img alt='close' src={closeIcon} />
                </div>
            </header>
            <main className="popup-main">
                {content}
            </main>
            <footer className="popup-footer">
                <div className="popup-dismiss">
                    <Checkbox className="popup-dismiss__checkbox" onChange={onChange} checked={checked} >{dismissLabel}</Checkbox>
                </div>
                <div className="popup-acts">
                    <button className="popup-btn-confirm" onClick={onConfirm}>{confirm}</button>
                    <button className="popup-btn-now" onClick={onGoNow}>{goNow}</button>
                </div>
            </footer>
        </div>
    );
}